import { Button, Header, Stack } from '@lessonnine/design-system.lib';
import PropTypes from 'prop-types';
import React from 'react';
// External Imports
import { connect } from 'react-redux';

import { actionCtaClicked } from '../../../actions/index.mjs';
import { options } from '../../../config/reactRedux.mjs';
import { LANGUAGES } from '../../../config/types/prop.mjs';
import { selectEdition } from '../../../selectors/selectEdition.mjs';
// Internal Imports
import { buildCTALink } from '../../../utils/url.mjs';
import { I18n } from '../../I18n/I18n.jsx';
import { SearchForm } from '../../SearchForm/SearchForm.jsx';
import { MobileNavExplore } from '../NavExplore/MobileNavExplore.jsx';

// Component Definition
function MenuNavBase({ currentEdition, dispatchActionCtaClicked }) {
  const ctaUrl = buildCTALink(currentEdition);
  return (
    <Stack gap={32}>
      {/* eslint-disable-next-line react/jsx-pascal-case -- External import */}
      <Header.h2>
        <I18n
          defaultText="Speak a new langauge with confidence"
          field="which-language-do-you-want-to-learn"
        />
      </Header.h2>
      <Button
        as="a"
        href={ctaUrl}
        onClick={() => dispatchActionCtaClicked({ placement: 'hamburger', url: ctaUrl })}
      >
        <I18n defaultText="Try Babbel" field="try-babbel" />
      </Button>
      <SearchForm />
      <MobileNavExplore />
    </Stack>
  );
}

MenuNavBase.propTypes = {
  currentEdition: LANGUAGES.isRequired,
  dispatchActionCtaClicked: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: selectEdition(state),
});

const mapDispatchToProps = (dispatch) => ({
  dispatchActionCtaClicked: (payload) => {
    dispatch(actionCtaClicked(payload));
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps, undefined, options);
const MenuNav = withRedux(MenuNavBase);

// Module Exports
export { MenuNav };
